export const ModalNames = {
  obligationDeleteModal: 'obligationDeleteModal',
};

export const NOLValues = {
  UTILIZE: 'UTILIZE',
  RECORD: 'RECORD',
};

export const countryCodes = {
  US: 'US',
};

export const usCountryTaxTypes = {
  US1: 'US1',
  US2: 'US2',
  US3: 'US3',
};


export const StatePrePostNOLOptions = [
  { label: 'Pre', value: 'PRE' },
  { label: 'Post', value: 'POST' },
];

export const NOLOptions = [
  { label: 'None', value: '' },
  { label: 'Utilize', value: 'UTILIZE' },
  { label: 'Record', value: 'RECORD' },
];

export const RecordVAOptions = [
  { label: 'None', value: '' },
  { label: 'All', value: 'ALL' },
  { label: 'NOL', value: 'NOL' },
];

export const FederalFTCLimitOptions = [
  { label: 'None', value: '' },
  { label: 'Y', value: 'Y' },
  { label: 'N', value: 'N' },
];

export const SecondaryTax = {
  None: '',
  Branch: 'Branch',
  Shareholder: 'Shareholder',
};

export const SecondaryTaxOptions = [
  { label: 'None', value: SecondaryTax.None },
  { label: 'Branch', value: SecondaryTax.Branch },
  { label: 'Shareholder', value: SecondaryTax.Shareholder },
];

export const EnabledFlagOptions = [
  { value: 'Y', label: 'Y' },
  { value: 'N', label: 'N' },
];

export const RecordFTCOptions = [
  { value: 'Y', label: 'Y' },
  { value: 'N', label: 'N' },
];


export const companyCodeRelatedFields = [
  'connectionName',
  'chartName',
  'usTaxType',
  'localTaxType',
  'functionalCurrency',
  'statCurrency',
];

export const obligationBasedFieldsToCopy = {
  usTaxType: 'usTaxType',
  usTaxTypeSource: 'usTaxTypeSource',
  localTaxType: 'localTaxType',
  localTaxTypeSource: 'localTaxTypeSource',
};

export const companyCodeBasedFieldsToCopy = {
  legalEntity: 'legalEntity',
  connectionName: 'connName',
  connectionNameSource: 'connName',
  chartName: 'chartName',
  chartNameSource: 'chartName',
  functionalCurrency: 'functionalCurrency',
  functionalCurrencySource: 'functionalCurrency',
  statCurrency: 'statCurrency',
  statCurrencySource: 'statCurrency',
  enabledFlag: 'enabledFlag',
};

export const fieldsToCopyWhenDomicileCountryCode = {
  recordFTC: 'recordFTC',
  recordFTCSource: 'recordFTC',
  secondaryTax: 'secondaryTax',
  secondaryTaxSource: 'secondaryTax',
  homeOfficeCompanyCode: 'homeOfficeCompanyCode',
  homeOfficeCompanyCodeSource: 'homeOfficeCompanyCode',
};
